import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { CardBody, CardTitle, Row, Col, Table } from "reactstrap";

const BankInformation = props => {
  return (
    <CardBody>
      {props.loading_details && (
        <LoaderStyled className="table-loader">
          <div className="spinner-border text-primary m-1" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </LoaderStyled>
      )}
      <Row
        style={{
          userSelect: "none",
          opacity: props.loading_details ? "0.5" : "1",
        }}
        className="mt-2"
      >
        <Col md={12}>
          <div className="d-flex" style={{ justifyContent: "space-between" }}>
            <div>
              <CardTitle className="mb-4 h4">Bank Information</CardTitle>
            </div>
            <div>
              {props.permissions["change_bankdetailsmodel"] && (
                <EditDataStyled
                  className="bx bx-pencil font-size-18 mw-2 float-end"
                  onClick={() => props.setEditBank(props.data)}
                />
              )}
            </div>
          </div>
        </Col>
      </Row>
      <Row
        style={{
          userSelect: "none",
          opacity: props.loading_details ? "0.5" : "1",
        }}
      >
        <div className="table-responsive">
          <Table className="table-nowrap mb-0">
            <tbody>
              <tr>
                <th scope="row">Company name :</th>
                <td>
                  {props.data?.company_name
                    ? props.data.company_name
                    : "Not found"}
                </td>
              </tr>
              <tr>
                <th scope="row">Company address :</th>
                <td>
                  {props.data?.company_address
                    ? props.data?.company_address
                    : "Not found"}
                </td>
              </tr>
              <tr>
                <th scope="row">Name of the bank :</th>
                <td>
                  {props.data?.name_of_the_bank
                    ? props.data?.name_of_the_bank
                    : "Not found"}
                </td>
              </tr>
              <tr>
                <th scope="row">Bank SWIFT :</th>
                <td>
                  {props.data?.bank_swift_code
                    ? props.data?.bank_swift_code
                    : "Not found"}
                </td>
              </tr>
              <tr>
                <th scope="row">Bank IBAN :</th>
                <td>
                  {props.data?.iban_code ? props.data?.iban_code : "Not found"}
                </td>
              </tr>
              <tr>
                <th scope="row">Bank EDRPOU :</th>
                <td>
                  {props.data?.bank_edrpou ? props.data?.bank_edrpou : "Not found"}
                </td>
              </tr>
              <tr>
                <th scope="row">Company details :</th>
                <td>
                  {props.data?.company_details
                    ? props.data?.company_details
                    : "Not found"}
                </td>
              </tr>
              <tr>
                <th scope="row">Payment description :</th>
                <td>
                  {props.data?.payment_description
                    ? props.data?.payment_description
                    : "Not found"}
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </Row>
    </CardBody>
  );
};

const LoaderStyled = styled.div`
  opacity: 1;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const EditDataStyled = styled.i`
  cursor: pointer;
  transition-duration: 0.5s;
  &:hover {
    color: #2684ff;
    transition-duration: 0.5s;
  }
`;

BankInformation.propTypes = {
  data: PropTypes.object.isRequired,
  setEditBank: PropTypes.func.isRequired,
  loading_details: PropTypes.bool.isRequired,
  permissions: PropTypes.any,
};

export default BankInformation;
